<script setup lang="ts">
defineProps<{ label: string }>();
</script>

<template>
  <span class="inline-flex shrink-0 items-center rounded bg-lagoon-100 text-primary text-base/6 px-4 py-2 font-semibold whitespace-nowrap">
    {{ label }}
  </span>
</template>
